
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-plans",
      function () {
        return require("private-next-pages/payment-plans/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-plans"])
      });
    }
  